export enum CurrencyUnit {
  USD = 'usd',
  EUR = 'eur',
  GBP = 'gbp',
}

export interface CreateQuoteBody {
  coverageStartDate: string;
  coverageEndDate: string;
  coverageStartHourNumber?: number;
  coverageEndHourNumber?: number;
  currency: string;
  exposureName: string;
  exposureLatitude: number;
  exposureLongitude: number;
  exposureTotalCoverageAmount: number;
  langLocale?: string;
}

export interface Quote {
  id: string;
  pricePerDay: number;
  totalPrice: number;
  dailyCoverageStartHour: number;
  dailyCoverageEndHour: number;
  sortedTiers: CoverageTier[];
  currency: CurrencyUnit;
  exposureProtections: ExposureProtection[];
  expiresAt: string;
  plainLanguage: PlainLanguage;
}

export interface MainPlainLanguage {
  title: string;
  body: string;
  action: string;
  loading?: string;
  open_details?: string;
  details_action: string;
  disclaimer: string;
  suggested_price: string;
  suggested_price_total: string;
}

export interface DetailsPlainLanguage {
  title: string;
  summary_heading: string;
  summary_times: string;
  summary_tiers: string[];
  summary_subheading: string;
  summary_body: string;
  summary_body_alt_unit: string;
  summary_explainer: string;
  steps_heading: string;
  step_1_heading: string;
  step_1_body: string;
  step_2_heading: string;
  step_2_body: string;
  step_3_heading: string;
  step_3_body: string;
  suggested_price: string;
  suggested_price_total: string;
  action: string;
  close: string;
  disclaimer: string;
}

export interface DocumentPlainLanguage {
  title: string;
  link: string;
}
export interface DocumentsPlainLanguage {
  privacy_policy: DocumentPlainLanguage;
  terms_conditions: DocumentPlainLanguage;
}
export interface PlainLanguage {
  main: MainPlainLanguage;
  details: DetailsPlainLanguage;
  documents: DocumentsPlainLanguage;
}

export interface CoverageTier {
  hours: number;
  reimbursementRate: number;
}

export interface ExposureProtection {
  name: ProtectionType;
  unit: string;
  upperThreshold?: number;
  lowerThreshold?: number;
}

export enum ProtectionType {
  RAINFALL = 'rainfall',
  TEMPERATURE = 'temperature',
  WIND = 'windspeed',
  AIR_QUALITY = 'air quality',
  SNOW = 'snow',
}

export enum EnvironmentName {
  PRODUCTION = 'production',
  SANDBOX = 'sandbox',
}
